import { useEffect, useRef } from "react";
import {
  involuntaryReasons,
  seperationTypes,
  voluntaryReasons,
} from "../../constants/seperation";
import { useDispatch, useSelector } from "react-redux";
import { businessUnit } from "../../constants/people";
import { getNoticePeriod } from "../../store/SeperationSlice/thunk";
import { seperationActions } from "../../store/SeperationSlice";
import EllipseIcon from "../../assets/icons/Ellipse 29.svg";
import ProgressIcon from "../../assets/icons/progress_activity_blue.svg";
import WarningIcon from "../../assets/icons/info_orange.svg";
import CustomDatePicker from "../../commonComponents/CustomDatePicker";
import CustomDropdown from "../../commonComponents/CustomDropdown";
import AttachmentIcon from "../../assets/icons/attach_email.svg";
import GroupIcon from "../../assets/icons/groups.svg";
import Close from "../../assets/icons/close.svg";
import CheckIconGrey from "../../assets/icons/check-grey.svg";
import CloseIconGrey from "../../assets/icons/close_grey.svg";
import moment from "moment";
import InitialsCircle from "../InitialsCircle";
import "./SeparationForm.css";

const SeparationForm = ({
  navRequired = true,
  confirmationRequired = true,
  onUpdate = () => {},
  formData,
  isError = false,
  changeFlow = () => {},
  isValidationError = false,
  fileMandatoryErr = false,
}) => {
  const dispatch = useDispatch();
  // const [seperationStage, setSeperationStage] = useState(1);
  const fileRef = useRef();
  const employeeID = useSelector((state) => state.auth.employeeID);
  const role = useSelector(
    (state) => state?.auth?.loginResponse?.body?.role_type || "",
  );
  const isReporteeSeperation = useSelector(
    (state) => state?.seperation?.isReporteeSeperation || "",
  );
  const employeeSelected = useSelector(
    (state) => state?.seperation?.employeeSelected || "",
  );
  const noticePeriod = useSelector(
    (state) => state.seperation.noticePeriodResponse?.data,
  );
  const fullName = useSelector(
    (state) => state.auth?.loginResponse?.display_name || "",
  );
  useEffect(() => {
    if (formData?.employee_id) {
      dispatch(getNoticePeriod({ employee_id: formData?.employee_id }));
    }
    return () => {
      dispatch(seperationActions.resetNoticePeriodDetails());
    };
  }, [dispatch, formData?.employee_id]);

  const getBusinessUnitColor = (unit) => {
    const color = businessUnit.find((item) => item.value === unit);
    return color ? color.color : "#000000";
  };

  const getValue = (field) => {
    if (field === null || field === undefined) return "NA";
    if (typeof field === "object" && field.value !== undefined)
      return field.value;
    return field;
  };

  return (
    <div className={`sp-fm ${confirmationRequired ? "h-85" : "h-80"}`}>
      {navRequired && (
        <>
          <div className="sp-fm-nav">
            <div className={`sp-nav-item sp-nav-active`}>
              <img src={ProgressIcon} className="sp-nav-ico" alt="" />
              Request for Separation
            </div>
            <div className="sp-nav-seperator"></div>
            <div className={`sp-nav-item`}>
              <img src={EllipseIcon} className="sp-nav-ico" alt="" />
              Manager Approval Stage
            </div>
            <div className="sp-nav-seperator"></div>
            <div className={`sp-nav-item `}>
              <img src={EllipseIcon} className="sp-nav-ico" alt="" />
              Clearance Tasks
            </div>
          </div>
        </>
      )}
      {isReporteeSeperation && (
        <div className="flex position-relative w-full">
          <div className="sp-user-box w-full">
            <div className="sp-user-empid">
              Employee ID #{employeeSelected?.employee_id}
            </div>
            <div className="flex w-full">
              {/* <img className="sp-user-ico" src={UserIcon} alt="User" /> */}
              <InitialsCircle
                fullName={employeeSelected?.full_name}
                size={24}
              />
              <div className="sp-user-name">{employeeSelected?.full_name}</div>
              <div
                className="flex sp-user-com ml-3"
                style={{
                  backgroundColor: getBusinessUnitColor(
                    getValue(employeeSelected?.business_unit),
                  ),
                }}
              >
                <img className="sp-user-icon" src={GroupIcon} alt="emp-icon" />
                <div className="sp-user-text">
                  {getValue(employeeSelected?.business_unit)}
                </div>
              </div>
            </div>
          </div>
          <div className="sp-close-ico" onClick={() => changeFlow()}>
            <img src={Close} alt="close" />
          </div>
        </div>
      )}
      {navRequired && !confirmationRequired && (
        <div className="sp-seperator"></div>
      )}
      <div className="sp-form-container">
        <div className="d-flex flex-column flex-lg-column flex-md-column flex-sm-column flex-xl-row">
          <div className="flex flex-col">
            <CustomDatePicker
              isRequired={true}
              showOptional={true}
              isError={isError}
              label={"Resignation Date"}
              value={formData?.resignation_date}
              onChange={(value) => {
                onUpdate({
                  value: value ? moment(value).format("YYYY-MM-DD") : "",
                  key: "resignation_date",
                });
              }}
              placeholderText={"Select a date"}
              reqLastDateErr={isValidationError}
              allowPastDate={false}
              allowFutureDate={false}
            />
          </div>
          {formData?.employee_id === employeeID ? (
            <>
              <div className="flex flex-col">
                <CustomDatePicker
                  isRequired={true}
                  showOptional={true}
                  isError={isError}
                  label={"Requested Last Date"}
                  value={formData?.req_last_date}
                  onChange={(value) => {
                    onUpdate({
                      value: value ? moment(value).format("YYYY-MM-DD") : "",
                      key: "req_last_date",
                    });
                  }}
                  placeholderText={"Select a date"}
                  allowFutureDate={true}
                  allowPastDate={false}
                  dateOfResignErr={isValidationError}
                />
              </div>
              <div className="flex flex-col">
                <div className="emp-form-label">Recovery Days*</div>
                <input
                  className={`emp-form-input ${
                    isError && !formData?.recovery_days && "error-border"
                  }`}
                  value={formData?.recovery_days || 0}
                  placeholder="Enter Recovery Days"
                  type="number"
                  disabled={true}
                />
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col">
                <CustomDatePicker
                  isRequired={true}
                  showOptional={true}
                  isError={isError}
                  label={"Final Date Of Exit"}
                  value={formData?.final_date_of_exit}
                  onChange={(value) => {
                    onUpdate({
                      value: value ? moment(value).format("YYYY-MM-DD") : "",
                      key: "final_date_of_exit",
                    });
                  }}
                  placeholderText={"Select a date"}
                  allowFutureDate={true}
                  allowPastDate={false}
                  // dateOfResignErr={isValidationError}
                />
              </div>
              <div className="flex flex-col">
                <div className="emp-form-label">Recovery Days*</div>
                <input
                  className={`emp-form-input ${
                    isError && !formData?.recovery_days && "error-border"
                  }`}
                  value={formData?.recovery_days}
                  placeholder="Enter Recovery Days"
                  type="number"
                  min="0"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      onUpdate({
                        value,
                        key: "recovery_days",
                      });
                    }
                  }}
                />
              </div>
            </>
          )}
        </div>
        {formData?.employee_id === employeeID && (
          <div className="sp-warning-text">
            <img src={WarningIcon} className="sp-nav-warning-ico" alt="" />
            Last Date As Per Notice Period is{" "}
            {moment(formData?.final_date_of_exit).format("DD MMMM YYYY")}(
            {noticePeriod} Days)
          </div>
        )}
      </div>
      <div className="sp-seperator"></div>
      <div className="sp-form-container">
        <div className="d-flex flex-column flex-lg-column flex-md-column flex-sm-column flex-xl-row">
          <div className="flex flex-col">
            <CustomDropdown
              showOptional={true}
              label={"Separation Type"}
              isError={isError}
              className="emp-form-input"
              options={
                role !== "USER" &&
                String(formData?.employee_id) !== String(employeeID)
                  ? seperationTypes
                  : ["Voluntary", "Involuntary"]
              }
              value={formData?.final_sepration_type}
              onSelectOption={(value) => {
                onUpdate({
                  value: value,
                  key: "final_sepration_type",
                });
              }}
              isRequired={true}
              isObjectDrop={false}
            />
          </div>
          <div className="flex flex-col">
            <CustomDropdown
              showOptional={true}
              label={"Reason of Resignation"}
              isError={isError}
              className="emp-form-input"
              options={
                formData?.final_sepration_type === "Voluntary"
                  ? voluntaryReasons
                  : formData?.final_sepration_type === "Involuntary"
                    ? involuntaryReasons
                    : formData?.final_sepration_type === "Death"
                      ? ["Death"]
                      : formData?.final_sepration_type === "Retirement"
                        ? ["Retirement"]
                        : []
              }
              value={formData?.reason}
              onSelectOption={(value) => {
                onUpdate({
                  value: value,
                  key: "reason",
                });
              }}
              isRequired={true}
              isObjectDrop={false}
              disabled={!formData?.final_sepration_type}
            />
          </div>
        </div>
      </div>
      <div className="sp-seperator"></div>
      {formData?.employee_id !== employeeID && (
        <div
          className={`flex flex-row question-box-common items-center rehire-box mt-3 mb-0 ${
            !formData.future_rehire && isError && "error-border"
          }`}
        >
          <div className="work-label">Rehire in Future?*</div>
          <div className="flex">
            <div
              className="flex items-center work-check-box"
              style={{
                border:
                  formData.future_rehire === "Yes"
                    ? "2px solid #172128"
                    : "none",
              }}
              onClick={() => {
                onUpdate({
                  value: "Yes",
                  key: "future_rehire",
                });
              }}
            >
              <img className="work-icon" src={CheckIconGrey} alt="work-icon" />
              <div className="work-check-label">Yes</div>
            </div>
            <div
              className="flex items-center work-check-box"
              onClick={() => {
                onUpdate({
                  value: "No",
                  key: "future_rehire",
                });
              }}
              style={{
                border:
                  formData.future_rehire === "No"
                    ? "2px solid #172128"
                    : "none",
              }}
            >
              <img className="work-icon" src={CloseIconGrey} alt="work-icon" />
              <div className="work-check-label">No</div>
            </div>
          </div>
        </div>
      )}
      {confirmationRequired && (
        <>
          <div className="sp-seperator"></div>
          <div className="confirmation">
            <div className="conf-head">confirmation</div>
            <div className="conf-ack flex flex-col">
              <div className="ack-content mb-12">
                I confirm that my personal mobile number and email address are
                up to date in the people HRMS system.
              </div>
              <div className="ack-content mb-12">
                I confirm that I have reviewed the instructions document and
                will adhere to them accordingly.
              </div>
              <div className="ack-content mb-12">
                I must get the required NOC by the last working day for my full
                and final settlement to be processed after clearing or
                submitting all company assets.
              </div>
              <div className="ack-content">
                I acknowledge that setting my requested last day before the last
                day specified in the notice period may result in a deduction.
              </div>
            </div>
            <div className="flex conf-check-box">
              <input
                type="checkbox"
                className="conf-check"
                onChange={(e) =>
                  onUpdate({ key: "submit_check", value: e.target.checked })
                }
                value={formData?.submit_check || ""}
              />
              <div className="conf-check-text text-left">
                I confirm that I’ve read all the points mentioned above.
              </div>
            </div>
          </div>
        </>
      )}
      <div
        className={`remarks-container d-flex flex-column flex-lg-row flex-md-row flex-xl-row w-100  mt-3 ${
          confirmationRequired ? "mt-3" : "mt-auto"
        }`}
      >
        {/* <img className="rq-emp-icon" src={UserIcon} alt="emp-icon" /> */}
        <div className="d-flex w-100">
          <InitialsCircle fullName={fullName} size={24} type="profile" />
          <input
            id="request-attachment-box"
            type="text"
            className={`request-attachment-box ${
              isError && !formData?.reason_comments && "error-border"
            }`}
            onChange={(e) =>
              onUpdate({
                value: e.target.value,
                key: "reason_comments",
              })
            }
            placeholder="Mention a comment along with your request"
            value={formData?.reason_comments || ""}
          />
        </div>

        <div
          className="attachment-button"
          style={{
            backgroundColor: fileMandatoryErr && !formData?.file && "red",
          }}
          onClick={() => document.getElementById("fileInput").click()}
        >
          {formData?.file && (
            <div
              className="file-attachment"
              onClick={() => onUpdate({ key: "file", value: "" })}
            >
              <img src={Close} alt="" />
            </div>
          )}
          <img src={AttachmentIcon} alt="" />
          <input
            id="fileInput"
            style={{
              display: "none",
              opacity: 0,
              height: "0px",
              width: "0px",
            }}
            type="file"
            onChange={(e) => {
              onUpdate({
                value: e.target.files[0],
                key: "file",
              });
            }}
            ref={fileRef}
          />

          <div className="attachment-button-text">
            {formData?.file?.name || "Attach Document"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SeparationForm;
